import { render, staticRenderFns } from "./index.vue?vue&type=template&id=34caf1d6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=34caf1d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34caf1d6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopicTitle: require('/usr/src/app/components/topic/title.vue').default,TopicHotCard: require('/usr/src/app/components/topic/hot-card.vue').default})
